import React, { useState } from 'react';
import './ConfirmExportModalContent.css';
import './ExportExcelModalContent.css';
import ExportProgressOverlay from '../../shared/ExportProgressOverlay';
import { PAGE_SIZE_A4, PAGE_SIZE_A3, PAGE_SIZE_ARCH_D } from '../../../../utilities/constants/pageSizeConstants';
import { resolveModalTask, clearModalTask } from '../modalTaskRegistry';
function ConfirmExportModalContent({ onClose, taskId, pageSize, format = 'PNG', pageOptions = [] }) {
  const [exporting, setExporting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('running');
  const [exportError, setExportError] = useState('');
  const formatUpper = (format || 'PNG').toUpperCase();
  const formatLower = formatUpper.toLowerCase();
  const isDxf = formatUpper === 'DXF';
  const showPageSelector = isDxf && Array.isArray(pageOptions) && pageOptions.length > 1;
  const [includeDesignElements, setIncludeDesignElements] = useState(true);
  const [selectedPageKey, setSelectedPageKey] = useState(pageOptions?.[0]?.value || '');

  const labelForSize = (ps) => {
    switch (ps) {
      case PAGE_SIZE_A4: return 'A4';
      case PAGE_SIZE_A3: return 'A3';
      case PAGE_SIZE_ARCH_D: return 'Arch D';
      default: return String(ps || 'A4');
    }
  };

  const handleConfirm = async () => {
    setExporting(true);
    setStatus('running');
    setExportError('');
    setProgress(0);
    const task = taskId ? resolveModalTask(taskId) : null;
    if (!task) {
      console.error('[ConfirmExportModalContent] No task registered for id', taskId);
      setStatus('error');
      setExportError('No se pudo iniciar la exportación.');
      return;
    }
    try {
      await task(setProgress, {
        includeDesignElements,
        selectedPageKey: showPageSelector ? selectedPageKey : '',
      });
      setProgress(100);
      setStatus('success');
      setTimeout(onClose, 500);
    } catch (error) {
      console.error('[ConfirmExportModalContent] Export failed', error);
      setStatus('error');
      setExportError(error?.message || 'No se pudo completar la exportación.');
    } finally {
      clearModalTask(taskId);
    }
  };

  return (
    <div className="excel-modal__content">
      {!exporting ? (
        <>
          <div className="excel-modal__title">Exportar {formatUpper}</div>
          <div className="excel-modal__subtitle">Exportar en formato {formatLower} con tamaño {labelForSize(pageSize)}</div>
          {isDxf && (
            <>
              <label className="confirm-export-option">
                <input
                  type="checkbox"
                  checked={includeDesignElements}
                  onChange={(event) => setIncludeDesignElements(event.target.checked)}
                />
                <p className="confirm-export-option__text">
                  <span>Incluir elementos de diseño</span>
                  <i>Solo los elementos gráficos en formato SVG serán visualizados en el archivo DXF.</i>
                </p>
              </label>
              {showPageSelector && (
                <label className="confirm-export-page">
                  <span>Hoja a exportar</span>
                  <select
                    value={selectedPageKey}
                    onChange={(event) => setSelectedPageKey(event.target.value)}
                  >
                    {pageOptions.map((page) => (
                      <option key={page.value} value={page.value}>
                        {page.label}
                      </option>
                    ))}
                  </select>
                </label>
              )}
            </>
          )}
          <div className="excel-modal__actions">
            <button className="excel-modal__button excel-modal__button--cancel" onClick={onClose}>Cancelar</button>
            <button className="excel-modal__button excel-modal__button--export" onClick={handleConfirm}>Exportar</button>
          </div>
        </>
      ) : (
        <ExportProgressOverlay
          progress={progress}
          status={status}
          error={exportError}
          message={`Exportando ${formatUpper}`}
          onClose={onClose}
        />
      )}
    </div>
  );
}

export default ConfirmExportModalContent;
